import { render, staticRenderFns } from "./ContactDetailCard.vue?vue&type=template&id=0e2801c0&scoped=true&"
import script from "./ContactDetailCard.vue?vue&type=script&lang=js&"
export * from "./ContactDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailCard.vue?vue&type=style&index=0&id=0e2801c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2801c0",
  null
  
)

export default component.exports